import { useExtendWithSubnetworks, useNetworksStateContext } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADSIDE } from "../../../../common/constants/appRoad"

import { roadsideQueryKeys } from "./queryKeys"
import { useRoadsideQuery } from "./useRoadsideQuery"

export function useRoadsideConditionsStats(parameters = {}, config = {}) {
    const url = "homogeneous_roadside_inventories/stats/conditions/"
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = useExtendWithSubnetworks({
        ...parameters,
        project: selectedNetwork.slug,
    }, API_MODULE_ROADSIDE)

    const queryKey = roadsideQueryKeys["conditionsStats"](queryParameters)

    return useRoadsideQuery(
        url,
        queryKey,
        queryParameters,
        {
            enabled: !!selectedNetwork,
            ...config,
        },
    )
}